import { render, staticRenderFns } from "./TransactionPopup.vue?vue&type=template&id=6ba45e06&"
import script from "./TransactionPopup.vue?vue&type=script&lang=js&"
export * from "./TransactionPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports